import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getCookie } from "../components/cookie/getCookie";
import { Domain } from "../Domain/Domain";
import { useDispatch } from "react-redux";
import { toggleAlertAction } from "../store/slices/alertSlice";

const useCreateProductHook = () => {
  const dispatch = useDispatch();
  const [showMoreSpecifications, setShowMoreSpecifications] =
    useState<boolean>(false);
  const [colors, setColor] = useState({});
  const [isSubmitting, setIsSUbmittng] = useState<boolean>(false);

  const [promotionalPriceIsHidden, setpromotionalPriceIsHidden] =
    useState<boolean>(true);

  // Toggling Promotional input
  const togglePromotionalHandler = () => {
    setpromotionalPriceIsHidden(!promotionalPriceIsHidden);
  };

  // Global unchn=ange
  const [enteredValue, setEnteredValue] = useState<{
    productName: string;
    brand: string;
    category: string;
    model: string;
    colours: string;
    productDescription: string;
    pricing: string;
    promotionalPrice: string;
    search_variables: string;
  }>({
    productName: "",
    brand: "",
    category: "",
    model: "",
    colours: "",
    productDescription: "",
    pricing: "",
    promotionalPrice: "",
    search_variables: ""
  });

  const [files, setFIles] = useState<{
    file1: string;
    file2: string;
    file3: string;
    file4: string;
  }>({
    file1: "",
    file2: "",
    file3: "",
    file4: "",
  });

  const [isLoadingImages, setIsloadingImages] = useState({
    loader1: false,
    loader2: false,
    loader3: false,
    loader4: false,
  });

  const onImageChangeHandler1 = (e: any) => {
    if (e.target.files[0].size > 5442880) {
      // return alert("File is too large");
      return dispatch(
        toggleAlertAction({
          isAlerting: true,
          message: "File is too large",
          status: "error",
        })
      );
    }
    let fileName = e.target.files[0].name;
    if (
      fileName.endsWith(".webp") ||
      fileName.endsWith(".svg") ||
      fileName.endsWith(".pjp") ||
      fileName.endsWith(".pjpeg") ||
      fileName.endsWith(".jfif ")
    ) {
      // return alert(
      //   "Please utilize supported formats, such as JPG and PNG, instead of file extensions that are not supported."
      // );
      return dispatch(
        toggleAlertAction({
          isAlerting: true,
          message:
            "Please utilize supported formats, such as JPG and PNG, instead of file extensions that are not supported.",
          status: "error",
        })
      );
    }

    setIsloadingImages((prevState) => {
      return {
        ...prevState,
        loader1: true,
      };
    });
    const formData = new FormData();
    formData.append("file", e.target.files[0]);
    var config = {
      onUploadProgress: function (progressEvent: any) {
        var percentCompleted = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        );

        console.log(percentCompleted);
        let uploadProductLoader1 = document.getElementById(
          "fileLoader1"
        ) as any;
        uploadProductLoader1.style.width = percentCompleted + "%";
        if (percentCompleted >= 100)
          setTimeout(() => {
            uploadProductLoader1.style.width = "0%";
          }, 1000);
      },
    };
    axios
      .post(Domain() + "/api/v1/file/new", formData, config)
      .then((response: any) => {
        console.log(response);
        setFIles((prevState) => {
          return {
            ...prevState,
            file1: response.data.data,
          };
        });
        setIsloadingImages((prevState) => {
          return {
            ...prevState,
            loader1: false,
          };
        });
      })
      .catch((error) => {
        console.log(error);
        // alert(
        //   "There was a problem this could be a network issue, thus posting a little image might be a good idea."
        // );
        dispatch(
          toggleAlertAction({
            isAlerting: true,
            message:
              "There was a problem this could be a network issue, thus posting a little image might be a good idea.",
            status: "error",
          })
        );
        setIsloadingImages((prevState) => {
          return {
            ...prevState,
            loader1: false,
          };
        });
      });
  };
  const onImageChangeHandler2 = (e: any) => {
    let fileName = e.target.files[0].name;
    if (
      fileName.endsWith(".webp") ||
      fileName.endsWith(".svg") ||
      fileName.endsWith(".pjp") ||
      fileName.endsWith(".pjpeg") ||
      fileName.endsWith(".jfif ")
    ) {
      // return alert(
      //   "Please utilize supported formats, such as JPG and PNG, instead of file extensions that are not supported."
      // );
      return dispatch(
        toggleAlertAction({
          isAlerting: true,
          message:
            "Please utilize supported formats, such as JPG and PNG, instead of file extensions that are not supported.",
          status: "error",
        })
      );
    }
    if (e.target.files[0].size > 5442880) {
      // return alert("FIle is too large");
      return dispatch(
        toggleAlertAction({
          isAlerting: true,
          message: "File is too large",
          status: "error",
        })
      );
    }
    setIsloadingImages((prevState) => {
      return {
        ...prevState,
        loader2: true,
      };
    });
    const formData = new FormData();
    formData.append("file", e.target.files[0]);

    var config = {
      onUploadProgress: function (progressEvent: any) {
        var percentCompleted = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        );

        console.log(percentCompleted);
        let uploadProductLoader1 = document.getElementById(
          "fileLoader2"
        ) as any;
        uploadProductLoader1.style.width = percentCompleted + "%";
        if (percentCompleted >= 100)
          setTimeout(() => {
            uploadProductLoader1.style.width = "0%";
          }, 1000);
      },
    };

    axios
      .post(Domain() + "/api/v1/file/new", formData, config)
      .then((response: any) => {
        console.log(response);
        setFIles((prevState) => {
          return {
            ...prevState,
            file2: response.data.data,
          };
        });
        setIsloadingImages((prevState) => {
          return {
            ...prevState,
            loader2: false,
          };
        });
      })
      .catch((error) => {
        console.log(error);
        // alert(
        //   "There was a problem this could be a network issue, thus posting a little image might be a good idea."
        // );
        dispatch(
          toggleAlertAction({
            isAlerting: true,
            message:
              "There was a problem this could be a network issue, thus posting a little image might be a good idea.",
            status: "error",
          })
        );
        setIsloadingImages((prevState) => {
          return {
            ...prevState,
            loader2: false,
          };
        });
      });
  };
  const onImageChangeHandler3 = (e: any) => {
    let fileName = e.target.files[0].name;
    if (
      fileName.endsWith(".webp") ||
      fileName.endsWith(".svg") ||
      fileName.endsWith(".pjp") ||
      fileName.endsWith(".pjpeg") ||
      fileName.endsWith(".jfif ")
    ) {
      // return alert(
      //   "Please utilize supported formats, such as JPG and PNG, instead of file extensions that are not supported."
      // );
      return dispatch(
        toggleAlertAction({
          isAlerting: true,
          message:
            "Please utilize supported formats, such as JPG and PNG, instead of file extensions that are not supported.",
          status: "error",
        })
      );
    }
    if (e.target.files[0].size > 5442880) {
      // return alert("FIle is too large");
      return dispatch(
        toggleAlertAction({
          isAlerting: true,
          message: "FIle is too large",
          status: "error",
        })
      );
    }

    setIsloadingImages((prevState) => {
      return {
        ...prevState,
        loader3: true,
      };
    });

    const formData = new FormData();
    formData.append("file", e.target.files[0]);
    var config = {
      onUploadProgress: function (progressEvent: any) {
        var percentCompleted = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        );

        console.log(percentCompleted);
        let uploadProductLoader1 = document.getElementById(
          "fileLoader3"
        ) as any;
        uploadProductLoader1.style.width = percentCompleted + "%";
        if (percentCompleted >= 100)
          setTimeout(() => {
            uploadProductLoader1.style.width = "0%";
          }, 1000);
      },
    };
    axios
      .post(Domain() + "/api/v1/file/new", formData, config)
      .then((response: any) => {
        console.log(response);
        setFIles((prevState) => {
          return {
            ...prevState,
            file3: response.data.data,
          };
        });
        setIsloadingImages((prevState) => {
          return {
            ...prevState,
            loader3: false,
          };
        });
      })
      .catch((error) => {
        console.log(error);
        // alert(
        //   "There was a problem this could be a network issue, thus posting a little image might be a good idea."
        // );
        dispatch(
          toggleAlertAction({
            isAlerting: true,
            message:
              "There was a problem this could be a network issue, thus posting a little image might be a good idea.",
            status: "error",
          })
        );
        setIsloadingImages((prevState) => {
          return {
            ...prevState,
            loader3: false,
          };
        });
      });
  };

  const onImageChangeHandler4 = (e: any) => {
    let fileName = e.target.files[0].name;
    if (
      fileName.endsWith(".webp") ||
      fileName.endsWith(".svg") ||
      fileName.endsWith(".pjp") ||
      fileName.endsWith(".pjpeg") ||
      fileName.endsWith(".jfif ")
    ) {
      // return alert(
      //   "Please utilize supported formats, such as JPG and PNG, instead of file extensions that are not supported."
      // );
      return dispatch(
        toggleAlertAction({
          isAlerting: true,
          message:
            "Please utilize supported formats, such as JPG and PNG, instead of file extensions that are not supported.",
          status: "error",
        })
      );
    }
    if (e.target.files[0].size > 5442880) {
      // return alert("FIle is too large");
      dispatch(
        toggleAlertAction({
          isAlerting: true,
          message: "FIle is too large",
          status: "error",
        })
      );
    }

    setIsloadingImages((prevState) => {
      return {
        ...prevState,
        loader4: true,
      };
    });
    const formData = new FormData();
    formData.append("file", e.target.files[0]);
    var config = {
      onUploadProgress: function (progressEvent: any) {
        var percentCompleted = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        );

        console.log(percentCompleted);
        let uploadProductLoader1 = document.getElementById(
          "fileLoader4"
        ) as any;
        uploadProductLoader1.style.width = percentCompleted + "%";
        if (percentCompleted >= 100)
          setTimeout(() => {
            uploadProductLoader1.style.width = "0%";
          }, 1000);
      },
    };
    axios
      .post(Domain() + "/api/v1/file/new", formData, config)
      .then((response: any) => {
        console.log(response);
        setFIles((prevState) => {
          return {
            ...prevState,
            file4: response.data.data,
          };
        });
        setIsloadingImages((prevState) => {
          return {
            ...prevState,
            loader4: false,
          };
        });
      })
      .catch((error) => {
        console.log(error);
        // alert(
        //   "There was a problem this could be a network issue, thus posting a little image might be a good idea."
        // );
        dispatch(
          toggleAlertAction({
            isAlerting: true,
            message:
              "There was a problem this could be a network issue, thus posting a little image might be a good idea.",
            status: "error",
          })
        );

        setIsloadingImages((prevState) => {
          return {
            ...prevState,
            loader4: false,
          };
        });
      });
  };

  const onChangeHandler = (e: any) => {
    setEnteredValue((prevState) => {
      return {
        ...prevState,
        [e.target.name]: e.target.value,
      };
    });
  };

  //   Chaging colors___________
  const onChangeColorHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    setColor((prevState) => {
      return {
        ...prevState,
        [e.target.id]: e.target.checked ? e.target.value : "",
      };
    });
  };

  const onShowMoreSpecifications = () => {
    setShowMoreSpecifications(!showMoreSpecifications);
  };

  // Submitting the file
  const onCreateProductHandler = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    // Validating the file

    let specAttributeID = document.querySelectorAll("#specAttributeID");
    let specValueID = document.querySelectorAll("#specValueID");
    let selectArray: any = [];
    let specValueArray: any = [];

    for (let i = 0; i < specAttributeID.length; i++) {
      for (let i = 0; i < specValueID.length; i++) {
        let specvalues = specValueID[i] as unknown as any;
        specValueArray.push({ value: specvalues.value });
        let selects = specAttributeID[i] as unknown as any;
        selectArray.push({ attribute: selects.value, value: specvalues.value });
      }
    }

    const newSelectedData = selectArray
      .map((cur: any) => {
        return {
          attribute: cur.attribute,
          value: cur.value,
        };
      })
      .splice(0, specAttributeID.length);

    // Remove empty string
    let newSpecData = [];
    for (let i = 0; i < newSelectedData.length; i++) {
      if (newSelectedData[i].value !== "") newSpecData.push(newSelectedData[i]);
    }

    const searchVariablesArray = enteredValue.search_variables.split(',').map(variable => variable.trim());

    let submittingData = {
      productName: enteredValue.productName,
      brand: enteredValue.brand,
      category: enteredValue.category,
      model: enteredValue.model,
      colours: Object.values(colors),
      productDescription: enteredValue.productDescription,
      specification: newSpecData,
      pictures: [files.file1, files.file2, files.file3, files.file4],
      pricing: enteredValue.pricing,
      promotionalPrice:
        enteredValue.promotionalPrice !== ""
          ? enteredValue.promotionalPrice
          : 0,
          search_variables: searchVariablesArray
    };

    setIsSUbmittng(true);

    axios
      .post(Domain() + "/api/v1/product/new", JSON.stringify(submittingData), {
        headers: {
          Authorization: getCookie(),
          "Content-Type": "application/json; charset=utf-8",
        },
      })

      .then((response: any) => {
        if (response.data.status === 200) {
          console.log(response);
          // alert(response.data.message);
          dispatch(
            toggleAlertAction({
              isAlerting: true,
              message: response.data.message,
              status: "",
            })
          );

          setTimeout(() => {
            window.location.reload();
          }, 2000);
          setIsSUbmittng(false);
          // navigate('')
          // TODO:  NAVIGATE TO PRODUCT PAGE
        }
      })
      .catch((error) => {
        console.log(error);
        setIsSUbmittng(false);
      });
  };

  return {
    onChangeHandler,
    onCreateProductHandler,
    showMoreSpecifications,
    onImageChangeHandler1,
    onImageChangeHandler2,
    onImageChangeHandler3,
    onImageChangeHandler4,
    files,
    onShowMoreSpecifications,
    enteredValue,
    onChangeColorHandler,
    isSubmitting,
    promotionalPriceIsHidden,
    togglePromotionalHandler,
    isLoadingImages,
  };
};

export default useCreateProductHook;
